import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'
import _ from 'lodash'

const state = {
  token: null,
  user: null,
  locations: [],
  groups: [],
  billboards: [],
  list_spaces_billboards: [],
  lang: 'en',
  start_date_spaces: null,
  duration_spaces: 30
}

const mutations = {
  setUser: (state, user) => {
    state.user = user
  },
  setLang: (state, lang) => {
    state.lang = lang
  },
  setToken: (state, token) => {
    state.token = token
  },
  setLocations: (state, result_locations) => {
    state.locations = result_locations;
  },
  setGroups: (state, result_groups) => {
    state.groups = result_groups;
  },
  setBillboards: (state, billboards) => {
    state.billboards = billboards;
  },
  setListSpaceBillboards: (state, result) => {
    state.list_spaces_billboards = result;
  },
  setStartDateSpaces: (state, date) => {
    state.start_date_spaces = date;
  },
  setDurationSpaces: (state, duration) => {
    state.duration_spaces = duration;
  },
  addBillboard: (state, billboard) => {
    state.billboards.push(billboard);
  },
  removeBillboard: (state, billboard) => {
    _.remove(state.billboards, o => {
      return o.id == billboard.id
    })
  },
  cleanListSpacesBillboards: (state) => {
    state.list_spaces_billboards.map((item) => {
      item.vallas = [];
    });
  },
}

const getters = {
  getUser: state => {
    return state.user
  },
  getLang: state => {
    return state.lang
  },
  getToken: state => {
    return state.token
  },
  getLocations: state => {
    return state.locations
  },
  getGroups: state => {
    return state.groups
  },
  getBillboards: state => {
    return state.billboards
  },
  getListSpacesBillboards: state => {
    return state.list_spaces_billboards;
  },
  getStartDateSpaces: state => {
    return state.start_date_spaces;
  },
  getDurationSpaces: state => {
    return state.duration_spaces;
  },
}

const actions = {
  changueUser: ({
    commit
  }, user) => {
    commit("setUser", user)
  },
  changueToken: ({
    commit
  }, token) => {
    commit("setToken", token)
  },
  logout: ({
    commit
  }, callback) => {
    commit("setToken", null);
    commit("setUser", null);
    //  commit("cleanListSpacesBillboards");
    if (callback) {
      callback();
    }
  },
  changue_lang: ({
    commit
  }, lang) => {
    commit("setLang", lang);
  },
  change_locations({
    commit
  }, result_locations) {
    commit("setLocations", result_locations);
  },
  change_groups({
    commit
  }, result_groups) {
    commit("setGroups", result_groups);
  },
  change_bilboards({
    commit
  }, billboards) {
    commit("setBillboards", billboards);
  },
  newBillboard({
    commit
  }, billboard) {
    commit("addBillboard", billboard);
  },
  delBillboard({
    commit
  }, billboard) {
    commit("addBillboard", billboard);
  },
  cleanListSpacesBillboards({
    commit
  }) {
    commit("cleanListSpacesBillboards");
  },
  change_list_spaces({
    commit
  }, result_spaces) {
    commit("setListSpaceBillboards", result_spaces);
  },
  change_start_date_spaces({
    commit
  }, date) {
    commit("setStartDateSpaces", date);
  },
  change_duration_spaces({
    commit
  }, duration) {
    commit("setDurationSpaces", duration);
  },
}

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [vuexLocal.plugin]
});